import React from 'react';

import { LinearProgress, Typography } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { useTranslation } from 'react-i18next';

import type { ActionLibraryInstanceStatus } from 'config/api/actionLibraryInstance/actionLibraryInstance.types';
import action_library_messages from 'messages/action_library_messages';

import useStyles from './ActionLibraryInstanceProgress.styles';

type ActionLibraryInstanceProgressProps = {
  hideCompletedBadge?: boolean;
  statusPercent: number;
  status?: ActionLibraryInstanceStatus;
};

const ActionLibraryInstanceProgress: React.FC<ActionLibraryInstanceProgressProps> = ({
  hideCompletedBadge = false,
  statusPercent,
  status = 'not_started',
}) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const rootClassName = status === 'completed' ? `${styles.root} ${styles.completedBar}` : styles.root;

  return (
    <div className={rootClassName}>
      <LinearProgress
        color='primary'
        style={{ height: 8, borderRadius: 4, width: '100%' }}
        value={Math.min(statusPercent ?? 0, 100)}
        variant='determinate'
      />
      <Typography variant='body2'>{`${statusPercent ?? 0}%`}</Typography>
      {!hideCompletedBadge && status === 'completed' && (
        <>
          <CheckCircleIcon className={styles.completedIcon} style={{ fontSize: '1.25rem', marginLeft: 4 }} />
          <Typography color='primary' style={{ fontWeight: 600 }} variant='body2'>
            {t(action_library_messages.instance.detail.instance_completed)}
          </Typography>
        </>
      )}
    </div>
  );
};

export default ActionLibraryInstanceProgress;
